import React, { useState, useEffect } from 'react';
import PromoBannerItem from 'components/PromoBannerItem/PromoBannerItem';
import promoImg1 from 'assets/images/promo-1.png';
import promoImg2 from 'assets/images/promo-2.png';

import s from './PromoBanner.module.scss';

export type Item = {
  image: string;
};

const items = [
  { image: promoImg1 },
  { image: promoImg2 },
];

const link = 'http://lk10.life.by/lp/flow/l_premium_playboy';

const PromoBanner = ({ className }: { className?: string }) => {
  const [randomItem, setRandomItem] = useState<Item | null>(null);

  useEffect(() => {
    const getRandomItem = () => {
      const shuffledItems = [...items].sort(() => 0.5 - Math.random());
      setRandomItem(shuffledItems[0]);
    };

    getRandomItem();
  }, []);

  const handleClick = () => {
    window.location.replace(link);
  };
  return (
    <div
      onClick={handleClick}
      className={`${s.promoBanner} ${className || ''}`}
      aria-hidden="true"
    >
      {randomItem && (
        <PromoBannerItem
          image={randomItem.image}
        />
      )}
    </div>
  );
};

PromoBanner.defaultProps = {
  className: '',
};

export default PromoBanner;
